import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=32679b52&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=32679b52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32679b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32679b52')) {
      api.createRecord('32679b52', component.options)
    } else {
      api.reload('32679b52', component.options)
    }
    module.hot.accept("./LandingPage.vue?vue&type=template&id=32679b52&scoped=true", function () {
      api.rerender('32679b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LandingPage.vue"
export default component.exports